import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { NewStepperComponent } from '@app/new-flow/components/new-stepper/newstepper.component';
import { ComponentsModule } from '@app/components/components.module';
import { CommonModule, DatePipe } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  correoConDosExtensiones,
  numericValidator,
  ValidateColombianPhone,
  ValidateEmail,
  ValidateForbiddenLastNames,
  ValidateForbiddenName,
} from '@app/utils/validadors';
import { Store } from '@ngrx/store';
import { OrquestadorService } from '@app/services/orquestador/orquestador.service';
import { GeneralDataService } from '@app/services/general/general-data.service';
import { removeData, setData } from 'src/storage/general.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { InactivityService } from '@app/services/inactivity/inactivity.service';
import { selectDataByKey } from 'src/storage/general.selectors';
import { debounceTime, Observable, Subscription, take } from 'rxjs';
import { LoaderService } from '@app/services/general/loader.service';
import { LeadResumeSyncService } from '@app/services/lead-resume/lead-resume-store-sync.service';
import { LeadResumeService } from '@app/services/lead-resume/lead-resume.service';
import { DataLayerService } from '@app/services/dataLeyer/data-leyer.service';
import { ensureLeadResumeDataInStore, ensureCriticalDataBeforeSubmit } from '@app/utils/lead-resume-sync-helpers.util';
import { LeadResumeProperty } from '@app/models/lead-resume';

@Component({
  selector: 'app-new-datos-propietario',
  // Converted to a declared (non-standalone) component to allow module-level declarations
  providers: [DatePipe],
  templateUrl: './new-datos-propietario.component.html',
  styleUrls: ['./new-datos-propietario.component.scss'],
})
export class NewDatosPropietarioComponent implements OnInit, OnDestroy {
  loaderService = inject(LoaderService);
  private leadResumeSyncService = inject(LeadResumeSyncService);
  private leadResumeService = inject(LeadResumeService);
  private _dataLayerService = inject(DataLayerService);
  route = inject(ActivatedRoute);;

  inactivityKeys: ('PolicyHolder' | 'Tenant' | 'Property' | 'ProductCode')[] = [
    'PolicyHolder',
    'Tenant',
    'Property',
    'ProductCode',
  ];

  myForm!: FormGroup;
  today: string;
  asesorCode: string = '';
  bitacoraId: string = '';
  body: any;
  generatedBody: any;
  errorMessage: string = '';
  inquilino$: Observable<any>;
  propietario$: Observable<any>;
  plan$: Observable<any>;
  property$: Observable<any>;
  propertyData: LeadResumeProperty | null = null;
  private subscriptions: Subscription = new Subscription();
  Tenant: any;
  Plan: any;
  isClicked: boolean = false;
  isLoading: boolean = false;
  loaded: boolean = false;
  synced: boolean = false;
  sessionId: string = '';
  private inactivityTimerActive: boolean = false;
  hideBackButton: boolean = false; // Ocultar botón volver si viene de retoma

  constructor(
    private router: Router,
    private orquestadorService: OrquestadorService,
    private inactivityService: InactivityService,
    private generalDataService: GeneralDataService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private store: Store
  ) {
    this.inquilino$ = this.store.select(selectDataByKey('Tenant'));
    this.propietario$ = this.store.select(selectDataByKey('PolicyHolder'));
    this.plan$ = this.store.select(selectDataByKey('Plan'));
    this.property$ = this.store.select(selectDataByKey('Property'));

    const todayDate = new Date();
    this.today = todayDate.toISOString().split('T')[0];

    this.myForm = this.fb.group({
      FirstName: ['',
        [Validators.required, Validators.maxLength(130), Validators.minLength(2), ValidateForbiddenName()]
      ],
      LastName: ['',
        [Validators.required, Validators.maxLength(60), Validators.minLength(3), ValidateForbiddenLastNames()]
      ],
      Mail: [
        '',
        [Validators.required, Validators.email, ValidateEmail()],
      ],
      CountryOfBirth: ['Colombia', [Validators.required]],
      DocumentType: ['C', [Validators.required]],
      DocumentNumber: [
        '',
        [
          Validators.required,
          Validators.minLength(7),
          Validators.maxLength(11),
          numericValidator(),
        ],
      ],
      ExpeditionDate: ['', [Validators.required]],
      MobilePhone: [
        '',
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          // numericValidator(),
          ValidateColombianPhone(),
        ],
      ],
      PersonalDataAuthorization: [false, Validators.requiredTrue],
    });
  }

  ngOnInit(): void {
    this.inactivityService.stopTimer();

    this.startInactivityTimer();

    // Escuchar CUALQUIER cambio en el formulario para reiniciar la cuenta regresiva
    this.subscriptions.add(
      this.myForm.valueChanges.pipe(
        debounceTime(300) // Evita reiniciar miles de veces por segundo al tipear
      ).subscribe(() => {
        console.log('⌨️ Usuario interactuando con el formulario. Reiniciando timer...');
        this.resetInactivityTimer();
      })
    );

    this.sessionId = this.getLocalStorage().toString();
    this.loaderService.show(); // Mostrar el loader al iniciar la carga de datos
    this.loaderService.loading$.subscribe(
      ({ loading, loaded }: { loading: boolean; loaded: boolean }) => {
        this.isLoading = loading;
        this.loaded = loaded;
      }
    );




    // 🔹 Si se sincronizaron datos, asegurar que los datos críticos estén en el store
    if (this.synced) {
      // ensureLeadResumeDataInStore(
      //   this.leadResumeService,
      //   this.leadResumeSyncService,
      //   this.store,
      //   'NewDatosPropietarioComponent'
      // );

      // También cargar Tenant en variable local para validación
      // const mappedData = this.leadResumeSyncService.getMappedData();
      // if (mappedData?.Tenant) {
      //   this.Tenant = mappedData.Tenant;
      // }

      // 🔹 Marcar que vino de retoma para ocultar botón volver
      console.log('🔄 Lead Resume detectado - Ocultando botón volver en banner');
      this.hideBackButton = true;
      this.store.dispatch(setData({
        key: 'isLeadResume',
        value: true,
        merge: false
      }));
    } else {
      // Si no se sincronizó ahora, verificar si hay flag de retoma en el store
      this.subscriptions.add(
        this.store.select(selectDataByKey('isLeadResume')).subscribe(isLeadResume => {
          if (isLeadResume) {
            console.log('🔄 Flag de Lead Resume detectado en store - Ocultando botón volver', isLeadResume);
            // 🔹 Lead Resume: Sincronizar TODOS los datos del Lead Resume con el store si existen
            console.log('🔄 Iniciando sincronización de Lead Resume...');
            // this.synced = this.leadResumeSyncService.syncAllLeadResumeData();
            console.log('📊 Lead Resume sincronizado:', this.synced ? 'Sí' : 'No');
            this.hideBackButton = true;
          }
        })
      );
    }

    // Suscribirse a los datos de Tenant del store para actualizaciones futuras
    this.subscriptions.add(
      this.inquilino$.subscribe((resume) => {
        if (resume) {
          console.log('✅ Tenant actualizado desde el store:', resume);
          this.Tenant = resume;
        } else if (!this.synced) {
          // Solo marcar como null si no hubo sincronización de Lead Resume
          console.log('ℹ️ Tenant no disponible en el store (usuario nuevo)');
          this.Tenant = null;
        }
      })
    );

    this.subscriptions.add(
      this.property$.subscribe((property) => {
        if (property) {
          this.propertyData = property;
        }
      })
    );

    // Primero intentar restaurar desde PolicyHolderFormData (datos guardados durante inactividad)
    this.subscriptions.add(
      this.store.select(selectDataByKey('PolicyHolderFormData')).subscribe(resume => {
        if (resume) {
          console.log('✅ Restaurando datos de formulario de propietario desde PolicyHolderFormData:', resume);
          this.myForm.patchValue({
            FirstName: resume.FirstName || '',
            LastName: resume.LastName || '',
            Mail: resume.Mail || '',
            // HU 36400 CA1: país de nacimiento del propietario quemado como "Colombia".
            CountryOfBirth: 'Colombia',
            DocumentType: resume.DocumentType || 'C',
            DocumentNumber: resume.DocumentNumber || '',
            ExpeditionDate: resume.ExpeditionDate || '',
            MobilePhone: resume.MobilePhone || '',
            PersonalDataAuthorization: resume.PersonalDataAuthorization || false
          });
        } else {
          console.log('ℹ️ No hay PolicyHolderFormData, intentando cargar desde PolicyHolder');
          // Si no hay PolicyHolderFormData, cargar desde PolicyHolder (datos del submit exitoso o Lead Resume)
          this.loadFromPolicyHolder();
        }
      })
    );

    // Suscribirse al código de asesor
    this.subscriptions.add(
      this.store.select(selectDataByKey('codigoAsesor')).subscribe(code => {
        if (code) {
          console.log('Código de asesor desde el store:', code);
          this.asesorCode = code;
        }
      })
    );

    // Suscribirse al Plan seleccionado
    this.subscriptions.add(
      this.plan$.subscribe((plan) => {
        if (plan) {
          console.log('✅ Plan actualizado desde el store:', plan);
          this.Plan = plan;
        }
      })
    );

    // Ocultar loader después de un breve delay para permitir que los datos se carguen
    setTimeout(() => this.loaderService.hide(), 500);

    // Verificar inmediatamente si los campos necesarios están completos
    this._dataLayerService.logDataNewFlow(
      'Arriendo_ecommerce_step_2_Datos_Propietario',
      'Arriendo',
      'Datos_Propietario',
      'Pageview',
      this.sessionId,
      {
        'Arma tu Plan': `${this.Plan?.armaTuPlan ?? ''}`,
        'Plan Esencial': `${this.Plan?.planEsencial ?? ''}`,
        'Plan Plus': `${this.Plan?.planPlus ?? ''}`
      }
    )
  }

  isModalOpen = false;

  DocumentType = [{ value: 'C', viewValue: 'Cédula de ciudadanía' }];

  private startInactivityTimer(): void {
    console.log('⏱️ Iniciando timer de inactividad desde la carga de la pantalla...');
    this.inactivityTimerActive = true;

    this.inactivityService.startInactivityTimer(
      'seguros/hogar/arriendo/cotizador/inactividad',
      undefined,
      this.inactivityKeys,
      '1', // Recuerda verificar si '10' en tu servicio son segundos o minutos
      'Abandono Datos del propietario',
      undefined,
      false,
      () => this.saveFormDataBeforeInactivity(),
      'Datos-propietario'
    );
  }

  /**
   * Reinicia la cuenta regresiva cuando se detecta actividad del usuario
   */
  private resetInactivityTimer(): void {
    if (this.inactivityTimerActive) {
      this.inactivityService.newresetTimer(
        this.inactivityKeys,
        '10',
        'Abandono Datos del propietario'
      );
    } else {
      this.startInactivityTimer();
    }
  }

  /**
   * Carga datos desde PolicyHolder (submit exitoso previo o Lead Resume)
   * Maneja correctamente la concatenación de nombres solo si existen
   */
  private loadFromPolicyHolder(): void {
    this.subscriptions.add(
      this.propietario$.subscribe((resume) => {
        if (resume) {
          console.log('✅ Cargando datos desde PolicyHolder del store:', resume);

          // Construir FirstName: solo concatenar SecondName si existe
          let firstName = resume.FirstName || '';
          if (resume.SecondName && resume.SecondName.trim() !== '') {
            firstName = `${firstName} ${resume.SecondName}`.trim();
          }

          // Construir LastName: solo concatenar SecondLastName si existe
          let lastName = resume.LastName || '';
          if (resume.SecondLastName && resume.SecondLastName.trim() !== '') {
            lastName = `${lastName} ${resume.SecondLastName}`.trim();
          }

          console.log('📋 Valores construidos:', {
            FirstName: firstName,
            LastName: lastName,
            Mail: resume.Mail,
            DocumentNumber: resume.DocumentNumber
          });

          this.myForm.patchValue({
            DocumentNumber: resume.DocumentNumber || '',
            DocumentType: resume.DocumentType || 'C',
            Mail: resume.Mail || '',
            FirstName: firstName,
            LastName: lastName,
            // HU 36400 CA1: país de nacimiento del propietario quemado como "Colombia".
            CountryOfBirth: 'Colombia',
            ExpeditionDate: resume.ExpeditionDate || '',
            MobilePhone: resume.MobilePhone || '',
            PersonalDataAuthorization: resume.PersonalDataAuthorization || false,
          });

          console.log('✅ Formulario actualizado desde PolicyHolder:', this.myForm.value);
        } else {
          console.log('ℹ️ No hay datos de PolicyHolder en el store (usuario nuevo)');
        }
      })
    );
  }

  openModal() {
    this.isModalOpen = true;
  }
  closeModal() {
    this.isModalOpen = false;
    this.isClicked = false;
  }

  isValidField(field: string) {
    const control = this.myForm.get(field);

    if (!control) {
      return false;
    }
    if (field === 'correo') {
    }
    return control.errors && control.touched;
  }

  submit() {
    this.isClicked = true;

    this._dataLayerService.logDataNewFlow(
      'Arriendo_ecommerce_step_2_Datos_Propietario',
      'Arriendo',
      'Datos_Propietario',
      'Button',
      this.sessionId,
      {
        'Arma tu Plan': `${this.Plan?.armaTuPlan ?? ''}`,
        'Plan Esencial': `${this.Plan?.planEsencial ?? ''}`,
        'Plan Plus': `${this.Plan?.planPlus ?? ''}`
      }
    )

    if (this.myForm.valid) {
      // Validación: Permitir submit si:
      // - No hay Tenant (usuario nuevo), O
      // - Tenant existe pero la cédula es diferente al propietario
      console.log('🔍 Validando Tenant:', {
        tenantExists: !!this.Tenant,
        tenantDocumentNumber: this.Tenant?.DocumentNumber,
        propietarioDocumentNumber: this.myForm.value.DocumentNumber
      });

      if (!this.Tenant || !this.Tenant.DocumentNumber || this.Tenant.DocumentNumber !== this.myForm.value.DocumentNumber) {
        console.log('✅ Validación Tenant exitosa: Cédulas diferentes o usuario nuevo');
        const formattedDate =
          this.datePipe.transform(new Date(), 'dd/MM/yyyy') || '';
        const formValues = this.myForm.value;
        const { firstName, secondName, LastName, secondLastName } = this.processFullName();
        // Aquí puedes agregar la lógica para enviar los datos

        const PolicyHolder = {
          ...formValues,
          FirstName: firstName,
          SecondName: secondName,
          LastName: LastName,
          SecondLastName: secondLastName,
          // HU 36400 CA1: país de nacimiento del propietario quemado como "Colombia".
          CountryOfBirth: 'Colombia',
          PersonalDataVersion: formattedDate,
          PersonalDataLastUpdated: formattedDate,
        };

        console.log('📋 Datos del propietario formateados para el store:', PolicyHolder);

        //Se elimina la información anterior para evitar merges incorrectos.
        this.store.dispatch(
          removeData({ key: 'PolicyHolder' })
        );

        this.store.dispatch(
          removeData({ key: 'PolicyHolderFormData' })
        );


        // 🔹 Asegurar que todos los datos críticos estén en el store antes de generar el body
        // ⚠️ IMPORTANTE: Excluir 'PolicyHolder' y 'Property' porque:
        // - PolicyHolder: el usuario acaba de llenar el formulario
        // - Property: el usuario llenó estos datos en la página anterior (inmueble) con ContractStartDate
        // y NO queremos sobrescribir los datos con valores viejos del Lead Resume
        this.store.dispatch(
          setData({
            key: 'PolicyHolder',
            value: PolicyHolder,
            merge: true,
          })
        );



        window.scrollTo(0, 0);
        this.loaderService.show();

        // Pequeño delay para asegurar que el store se actualice antes de getbody()
        setTimeout(() => {
          const options: any = {
            keys: ['PolicyHolder', 'Tenant', 'Property'],
            leadId: 'leadId',
            screenPercentage: '30',
            getLeadDuplicated: true,
            asesorCode: this.asesorCode !== '' ? this.asesorCode : undefined,
            bitacoraId: this.bitacoraId !== '' ? this.bitacoraId : undefined,
          };



          this.store.dispatch(
            setData({
              key: 'PolicyHolderFormData',
              value: this.myForm.value,
              merge: true,
            })
          );

          console.log('📤 Generando body con opciones:', options);


          this.generalDataService.getbody(options).subscribe((body) => {

            this.generatedBody = body;
            this.generatedBody.productsConfigurationData.Property =

              this.generatedBody.productsConfigurationData.Property = {
                ...this.propertyData,
                ContractStartDate: this.propertyData?.ContractStartDate || "",
                Department: this.propertyData?.Department || "",
                CityProperty: this.propertyData?.CityProperty || "",
                DepartmentCode: this.propertyData?.DepartmentCode || "",
                CityCode: this.propertyData?.CityCode || "",
                Code: this.propertyData?.Code || "",
              };

            // Función que ejecuta la llamada al orquestador
            const executeOrquestadorCall = () => {

              console.log('this.generatedBody completo:', this.generatedBody);

              this.generatedBody.getOwnerPolicies = true;
              this.generatedBody.getLeadDuplicated = true;


              this.orquestadorService
                .postOrquestador(this.generatedBody)
                .subscribe({
                  next: (response) => {
                    console.log('Response from orquestador :', response);
                    //this.loaderService.show();

                    if (response.error) {
                      this.errorMessage =
                        'Error al procesar la solicitud. Por favor intenta nuevamente.';
                    } else {
                      // Verificar si viene política de lead duplicados
                      if (response.data?.Politica === 'Politica de lead duplicados') {
                        this.loaderService.hide();
                        this.inactivityService.stopTimer();

                        if (response.data.UrlRetoma !== '') {

                          this.store.dispatch(setData({
                            key: 'leadDuplicatedData',
                            value: response.data,
                            merge: true,
                          }));
                          this.router.navigate(['seguros/hogar/arriendo/cotizador/retoma']);
                          return;
                        }

                        console.log('Lead duplicado detectado - Redirigiendo a tenemos-tus-datos');
                        this.router.navigate(['seguros/hogar/arriendo/cotizador/tenemos-tus-datos']);
                        return;
                      }
                      if (response.data?.owner === true) {
                        // owner true
                        console.log('Hay pólizas de propietario disponibles - Redirigiendo a otro-producto');
                        this.loaderService.hide();
                        this.inactivityService.stopTimer();
                        this.router.navigate(['seguros/hogar/arriendo/cotizador/otro-producto']);
                        return;
                      }
                      if (response.data?.owner === false) {
                        // body para consultar riesgos
                        const customBody: any = {
                          SessionId: body.SessionId,
                          getRiesgos: true,
                          Producto: 'DigitalArrendamientos',
                          leadId: this.generatedBody.leadId || body.leadId,
                          productsConfigurationData: {
                            Tenant: {
                              DocumentNumber:
                                this.generatedBody.productsConfigurationData?.Tenant
                                  ?.DocumentNumber,
                              DocumentType:
                                this.generatedBody.productsConfigurationData?.Tenant
                                  ?.DocumentType,
                            },
                            PolicyHolder: {
                              DocumentNumber:
                                this.generatedBody.productsConfigurationData
                                  ?.PolicyHolder?.DocumentNumber,
                              DocumentType:
                                this.generatedBody.productsConfigurationData
                                  ?.PolicyHolder?.DocumentType,
                            },
                          },
                        };

                        console.log('📋 leadId en customBody (segunda llamada):', customBody.leadId ? `✅ ${customBody.leadId}` : '⚠️ No disponible');

                        if (this.generatedBody.asesorCode) {
                          customBody.asesorCode = this.generatedBody.asesorCode;
                        }
                        if (this.generatedBody.bitacoraId) {
                          customBody.bitacoraId = this.generatedBody.bitacoraId;
                        }

                        this.orquestadorService
                          .postOrquestador(customBody)
                          .subscribe({
                            next: (customResponse) => {
                              console.log(
                                'Custom response from orquestador:',
                                customResponse
                              );

                              const dataArr = customResponse?.data;
                              if (Array.isArray(dataArr) && dataArr.length >= 2) {
                                const riesgo0 = dataArr[0]?.esRiesgo;
                                const riesgo1 = dataArr[1]?.esRiesgo;

                                if (riesgo0 === false && riesgo1 === false) {
                                  // Ambos sin riesgo
                                  this.loaderService.hide();
                                  this.inactivityService.stopTimer();
                                  // this.router.navigate(['info-complementarios-propiedad'], { relativeTo: this.route.parent });
                                  this.router.navigate(['seguros/hogar/arriendo/cotizador/datos-inmueble']);
                                } else if (riesgo0 === true && riesgo1 === false) {
                                  this.loaderService.hide();
                                  // Solo el primero con riesgo
                                  this.router.navigate(['seguros/hogar/arriendo/cotizador/lo-sentimos']);
                                } else if (riesgo0 === false && riesgo1 === true) {
                                  // Solo el segundo con riesgo
                                  //this.router.navigate([SARLAFT_FEEDBACK], { relativeTo: this.route.parent });
                                  this.loaderService.hide();
                                  this.router.navigate(['seguros/hogar/arriendo/cotizador/no-cumple-politicas']);
                                } else {
                                  // Ambos con riesgo u otro caso
                                  //this.router.navigate([SARLAFT_END], { relativeTo: this.route.parent });
                                  this.loaderService.hide();
                                  this.router.navigate(['seguros/hogar/arriendo/cotizador/lo-sentimos']);
                                }
                              } else {
                                this.errorMessage =
                                  'Respuesta inesperada del servicio de riesgos.';
                                this.loaderService.hide();
                                this.router.navigate(['seguros/hogar/arriendo/cotizador/tenemos-tus-datos']);
                              }
                            },
                            error: (error) => {
                              console.error('Error in custom request:', error);

                              this.errorMessage =
                                'Error al procesar la solicitud personalizada. Por favor intenta nuevamente.';
                            },
                          });

                        console.log('Custom body:', customBody);

                        console.log('No hay pólizas de propietario disponibles');
                      }
                    }
                  },
                });
            };

            // Verificar si ya existe leadId o si necesita obtenerse del store
            if (this.generatedBody.leadId) {
              // Ya existe leadId, ejecutar inmediatamente
              console.log('✅ leadId ya presente en generatedBody, ejecutando llamada al orquestador');
              executeOrquestadorCall();
            } else {
              // No existe leadId, intentar obtenerlo del store
              console.warn('⚠️ leadId no encontrado en body generado, intentando obtener del store');
              this.subscriptions.add(
                this.store.select(selectDataByKey('leadId')).pipe(take(1)).subscribe(leadId => {
                  if (leadId) {
                    this.generatedBody.leadId = leadId;
                    console.log('✅ leadId recuperado del store:', leadId);
                    // Ejecutar la llamada al orquestador DESPUÉS de obtener el leadId
                    executeOrquestadorCall();
                  } else {
                    console.error('❌ No se pudo obtener leadId ni del body ni del store');
                    // Ejecutar de todas formas (el backend podría manejarlo)
                    executeOrquestadorCall();
                  }
                })
              );
            }
          });


        }, 0); // Fin del setTimeout - permite que el store se actualice
      } else {
        console.log('⚠️ Validación Tenant fallida: La cédula del inquilino es igual a la del propietario');
        this.openModal();
      }
    } else {
      console.log('Faltan campos obligatorios');
      this.myForm.markAllAsTouched();
    }
  }

  /**
   * Verifica si los campos requeridos están completos y válidos
   * Campos requeridos: DocumentNumber, DocumentType y al menos uno de (Mail O MobilePhone)
   * Si están completos, inicia el timer de inactividad. Si no, lo detiene.
   */

  /**
   * Guarda los datos actuales del formulario en el store antes de la redirección por inactividad
   */
  private saveFormDataBeforeInactivity(): void {
    console.log('Guardando datos del formulario de propietario antes de inactividad');

    const formValues = this.myForm.value;

    // Guardar datos del formulario en una key específica para restauración
    const PolicyHolderFormData = {
      FirstName: formValues.FirstName || '',
      LastName: formValues.LastName || '',
      Mail: formValues.Mail || '',
      // HU 36400 CA1: país de nacimiento del propietario quemado como "Colombia".
      CountryOfBirth: 'Colombia',
      DocumentType: formValues.DocumentType || 'C',
      DocumentNumber: formValues.DocumentNumber || '',
      ExpeditionDate: formValues.ExpeditionDate || '',
      MobilePhone: formValues.MobilePhone || '',
      PersonalDataAuthorization: formValues.PersonalDataAuthorization || false
    };

    this.store.dispatch(
      setData({
        key: 'PolicyHolderFormData',
        value: PolicyHolderFormData,
        merge: true,
      })
    );

    // También guardar en formato PolicyHolder para el orquestador
    const formattedDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy') || '';
    const PolicyHolder = {
      FirstName: formValues.FirstName || '',
      LastName: formValues.LastName || '',
      Mail: formValues.Mail || '',
      // HU 36400 CA1: país de nacimiento del propietario quemado como "Colombia".
      CountryOfBirth: 'Colombia',
      DocumentType: formValues.DocumentType || 'C',
      DocumentNumber: formValues.DocumentNumber || '',
      ExpeditionDate: formValues.ExpeditionDate || '',
      MobilePhone: formValues.MobilePhone || '',
      PersonalDataAuthorization: formValues.PersonalDataAuthorization || false,
      PersonalDataVersion: formattedDate,
      PersonalDataLastUpdated: formattedDate,
    };

    this.store.dispatch(
      setData({
        key: 'PolicyHolder',
        value: PolicyHolder,
        merge: true, // No hacer merge, reemplazar completamente para asegurar que se envíen todos los datos
      })
    );

    console.log('Datos de propietario guardados en store para orquestador:', { PolicyHolderFormData, PolicyHolder });
  }

  ngOnDestroy(): void {
    // Detener el servicio de inactividad al destruir el componente
    this.inactivityService.stopTimer();
    this.subscriptions.unsubscribe();
  }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'));
  }


  processFullName(): { firstName: string; secondName: string; LastName: string; secondLastName: string } {
    const formulario = this.myForm;
    const nameValue = formulario.get('FirstName')?.value || '';
    const lastNameValue = formulario.get('LastName')?.value || '';
    const nameParts = nameValue.match(/\S+/g) || [];
    const lastNameParts = lastNameValue.match(/\S+/g) || [];
    const firstName = nameParts[0] || '';
    const secondName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';
    const LastName = lastNameParts[0] || '';
    const secondLastName = lastNameParts.length > 1 ? lastNameParts.slice(1).join(' ') : '';

    return {
      firstName,
      secondName,
      secondLastName,
      LastName
    }
  }
}
